import { isNestApiAvailable } from "../nest/client"

export interface RuntimeWorkspaceContext {
    workspaceId: string
    workspaceRoot: string
    worktreeId?: string
}

export interface NestRuntimePathParams {
    workspaceId: string
    cwd: string
    worktreeId?: string
}

export function normalizePath(path: string): string {
    return path.replace(/\\/g, "/").replace(/\/+/g, "/")
}

export function trimTrailingSlash(path: string): string {
    const normalized = normalizePath(path)
    return normalized.length > 1 ? normalized.replace(/\/+$/g, "") : normalized
}

export function relativeFromWorkspaceRoot(root: string, path: string): string {
    const normalizedRoot = trimTrailingSlash(root)
    const normalizedPath = trimTrailingSlash(path)
    if (normalizedPath === normalizedRoot) return "."
    const prefix = `${normalizedRoot}/`
    if (normalizedPath.startsWith(prefix)) return normalizedPath.slice(prefix.length)
    throw new Error(`Path is outside workspace root: ${path}`)
}

export function requireRuntimeWorkspaceContext(context: RuntimeWorkspaceContext | undefined, operation: string): RuntimeWorkspaceContext {
    if (!isNestApiAvailable()) throw new Error("Nest API is required")
    if (!context?.workspaceId || !context.workspaceRoot) {
        throw new Error(`${operation} requires Nest workspace context`)
    }
    return context
}

export function nestRuntimeParamsForCwd(cwd: string, context: RuntimeWorkspaceContext): NestRuntimePathParams {
    return {
        workspaceId: context.workspaceId,
        cwd: relativeFromWorkspaceRoot(context.workspaceRoot, cwd),
        ...(context.worktreeId ? { worktreeId: context.worktreeId } : {}),
    }
}
